import { render, staticRenderFns } from "./BasicInfoForm.vue?vue&type=template&id=149d779a&"
import script from "./BasicInfoForm.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfoForm.vue?vue&type=style&index=0&id=149d779a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports